<script setup>

import Container from "@/Components/Container.vue";

const props = defineProps({
    title: {
        type: String,
        required: true,
    },
});
</script>

<template>
    <div class="w-full bg-gray-50 py-1 md:pt-3 shadow-inner">
        <Container>
            <div class="flex items-center justify-between">
                <h1 class="text-4xl font-bold tracking-tight text-gray-900">{{ title }}</h1>
                <slot/>
            </div>
        </Container>
    </div>
</template>
